import script from "./EditVacancy.vue?vue&type=script&setup=true&lang=js"
export * from "./EditVacancy.vue?vue&type=script&setup=true&lang=js"

import "./EditVacancy.vue?vue&type=style&index=0&id=56efc612&scoped=true&lang=css"
import "./EditVacancy.vue?vue&type=style&index=1&id=56efc612&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-56efc612"]])

export default __exports__